import { render, staticRenderFns } from "./BankAccountDocument.vue?vue&type=template&id=4fed9a09&scoped=true"
import script from "./BankAccountDocument.vue?vue&type=script&lang=ts"
export * from "./BankAccountDocument.vue?vue&type=script&lang=ts"
import style0 from "./BankAccountDocument.vue?vue&type=style&index=0&id=4fed9a09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fed9a09",
  null
  
)

export default component.exports